import { useEffect } from 'react'

/**
 * Closes the menu when the user presses Escape while it is open.
 */
export const useEscapeToClose = (isOpen: boolean, setOpen: (open: boolean) => void): void => {
  useEffect(() => {
    if (!isOpen) return
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    globalThis.addEventListener('keydown', handleKeyDown)
    return () => globalThis.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, setOpen])
}
